import {
  customTitle,
  getTenantName,
  hasPermission,
  isAdmin,
  isDevEnv,
  isLinksEdu,
  isLyceum,
  isLyceumDevEnv,
  isProdEnv,
  isStaff,
  isTeacher,
} from 'common/HelperFunctions'
import {GENERAL_ENABLE_DISABLE} from 'common/constants'
import {
  isAttendanceBetaEnabled,
  isHomeworkBetaEnabled,
  isHomeworkBetaToggleEnabled,
  isNewHomeworkDisabled,
} from 'common/helpers'
import {MainReducer, UserReducer} from 'setup'

import {Link} from './types'

export const getAsideMenuLinks = ({
  mainReducer,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  userReducer,
}: {
  mainReducer: MainReducer
  userReducer: UserReducer
}): Link[] => {
  const {generalSettings} = mainReducer

  let show_admissions_manger =
    hasPermission('user_manager_in_active_users') &&
    generalSettings?.admission_form_permission === 1
  if (isProdEnv() && isLyceum()) {
    show_admissions_manger = false
  }

  return [
    {
      to: '/dashboard',
      title: 'MENU.DASHBOARD',
      fontIcon: 'fas fa-home',
      visible: hasPermission('dashboard'),
    },

    /**
     * Administration
     */
    {
      type: 'label',
      title: 'MENU.ADMINISTRATION',
      to: '',
      visible:
        hasPermission('attendance_manager') ||
        hasPermission('branch_level_manager') ||
        hasPermission('class_subject_manager') ||
        hasPermission('department_manager') ||
        hasPermission('digital_request_manager') ||
        hasPermission('news_manager') ||
        hasPermission('resource_manager') ||
        hasPermission('schedule_manager') ||
        hasPermission('tags_manager') ||
        hasPermission('user_manager'),
    },

    {
      to: '',
      title: 'MENU.ADMISSIONS',
      fontIcon: 'fas fa-user-plus',
      visible: show_admissions_manger,
      subLinks: [
        {
          to: '/institute/admission/list',
          title: 'MENU.NEW_ADMISSIONS',
          fontIcon: 'fas fa-user',
        },
        {
          to: '/institute/admission/report',
          title: 'MENU.NEW_ADMS_REPORT',
          fontIcon: 'fas fa-copy',
          visible: false,
        },
        {
          to: '/institute/admission/summary-report',
          title: 'MENU.NEW_ADMS_SUMMARY_REPORT',
          fontIcon: 'fas fa-copy',
          visible: false,
        },

        {
          to: '/institute/admission/settings',
          title: 'MENU.ADMISSION_SETTINGS',
          fontIcon: 'fas fa-wrench',
        },
      ],
    },

    {
      to: '',
      title: 'MENU.ATTENDANCE',
      fontIcon: 'far fa-edit',
      visible: hasPermission('attendance_manager'),
      subLinks: [
        {
          to:
            isDevEnv() || isAttendanceBetaEnabled()
              ? '/institute/attendance/setting/'
              : '/institute/attendance/setting/',
          title: 'MENU.ATTENDANCE_SETTING',
          fontIcon: 'fas fa-wrench',
          visible: hasPermission('attendance_manager_settings'),
        },
        {
          to: '/institute/attendance/teacher',
          title: 'MENU.TEACHER/STAFF_ATTENDANCE',
          fontIcon: 'far fa-edit',
          visible:
            hasPermission('attendance_manager_teacher_staff_attendance') &&
            hasPermission('attendance_manager_create'),
        },
        {
          to:
            isDevEnv() || isAttendanceBetaEnabled()
              ? '/institute/attendance/teacher-subject'
              : '/institute/attendance/teacherSubject',
          title: 'MENU.TEACHER_SUBJECT_ATTENDANCE',
          fontIcon: 'far fa-edit',
          visible:
            hasPermission('attendance_manager_teacher_subject_attendance') &&
            generalSettings?.subject_attendance === GENERAL_ENABLE_DISABLE.ENABLE &&
            hasPermission('attendance_manager_create'),
        },
        {
          to:
            isDevEnv() || isAttendanceBetaEnabled()
              ? '/institute/attendance/teacher-report/individual'
              : '/institute/attendanceReport/teacherreport',
          title: 'MENU.TEACHER/STAFF_ATTENDANCE_REPORTS',
          fontIcon: 'fas fa-copy',
          visible:
            hasPermission('attendance_manager_teacher_staff_attendance_report') &&
            hasPermission('attendance_manager_view'),
        },
        {
          to:
            isDevEnv() || isAttendanceBetaEnabled()
              ? '/institute/attendance/teacher-subject-report/individual'
              : '/institute/attendanceReport/teacherReportSubject',
          title: 'MENU.TEACHER_SUBJECT_ATTENDANCE_REPORTS',
          fontIcon: 'fas fa-copy',
          visible:
            hasPermission('attendance_manager_teacher_subject_attendance_report') &&
            generalSettings?.subject_attendance === GENERAL_ENABLE_DISABLE.ENABLE &&
            hasPermission('attendance_manager_view'),
        },
        {
          to: '/institute/attendance/student',
          title: 'MENU.STUDENT_ATTENDANCE',
          fontIcon: 'far fa-edit',
          visible:
            hasPermission('attendance_manager_student_attendance') &&
            hasPermission('attendance_manager_create'),
        },
        {
          to:
            isDevEnv() || isAttendanceBetaEnabled()
              ? '/institute/attendance/student-subject'
              : '/institute/attendance/studentSubject',
          title: 'MENU.STUDENT_SUBJECT_ATTENDANCE',
          fontIcon: 'far fa-edit',
          visible:
            hasPermission('attendance_manager_student_subject_attendance') &&
            generalSettings?.subject_attendance === GENERAL_ENABLE_DISABLE.ENABLE &&
            hasPermission('attendance_manager_create'),
        },
        {
          to:
            isDevEnv() || isAttendanceBetaEnabled()
              ? '/institute/attendance/student-report/individual'
              : '/institute/attendanceReport/studentreport',
          title: 'MENU.STUDENT_ATTENDANCE_REPORTS',
          fontIcon: 'fas fa-copy',
          visible:
            hasPermission('attendance_manager_student_attendance_report') &&
            hasPermission('attendance_manager_view'),
        },
        {
          to:
            isDevEnv() || isAttendanceBetaEnabled()
              ? '/institute/attendance/student-subject-report/individual'
              : '/institute/attendanceReport/studentReportSubject',
          title: 'MENU.STUDENT_SUBJECT_ATTENDANCE_REPORTS',
          fontIcon: 'fas fa-copy',
          visible:
            hasPermission('attendance_manager_student_subject_attendance_report') &&
            generalSettings?.subject_attendance === GENERAL_ENABLE_DISABLE.ENABLE &&
            hasPermission('attendance_manager_view'),
        },
        {
          to: '/institute/attendance/student-subject/combined-report',
          title: 'MENU.STUDENT_SUBJECT_COMBINED_ATTENDANCE_REPORTS',
          fontIcon: 'fas fa-copy',
          visible:
            hasPermission('attendance_manager_student_subject_attendance_report') &&
            generalSettings?.subject_attendance === GENERAL_ENABLE_DISABLE.ENABLE &&
            hasPermission('attendance_manager_view'),
        },
        {
          to: '/institute/attendanceAmendmentRequest/amendmentRequest',
          title: 'ATTENDANCE.MARKED_THROUGH.ATTENDANCE_AMENDMENT_REQUEST',
          fontIcon: 'far fa-edit',
          visible: hasPermission('attendance_manager_attendance_amendment_requests'),
        },
        {
          to: '/institute/userCustomAtendanceSchedule/admin',
          title: 'MENU.ATTENDANCE_SCHEDULE',
          fontIcon: 'far fa-file',
          visible: hasPermission('attendance_manager_attendance_schedule'),
        },
        {
          to: '/institute/attendance/biometricAttendanceUpload/',
          title: 'MENU.ATTENDANCE_UPLOAD',
          fontIcon: 'fas fa-cloud-upload-alt',
          visible: hasPermission('attendance_manager_attendance_upload'),
        },
      ],
    },

    {
      to: '',
      title: 'MENU.BRANCHES_&_LEVELS',
      fontIcon: 'fab fa-buromobelexperte',
      visible: hasPermission('branch_level_manager'),
      subLinks: [
        {
          to: '/institute/branches/list',
          title: 'MENU.BRANCHES',
          fontIcon: 'fab fa-buromobelexperte',
          visible: hasPermission('branch_level_manager_branches'),
        },
        {
          to: '/institute/level/list',
          title: 'MENU.LEVELS',
          fontIcon: 'fab fa-buromobelexperte',
          visible: hasPermission('branch_level_manager_levels'),
        },
      ],
    },

    {
      to: '/institute/departments',
      title: 'MENU.DEPARTMENTS',
      fontIcon: 'fab fa-buromobelexperte',
      visible: hasPermission('department_manager'),
    },

    {
      to: '/institute/digital-requests',
      title: 'MENU.LEAVE_APPLICATIONS',
      fontIcon: 'fas fa-envelopes-bulk',
      visible: hasPermission('digital_request_manager'),
    },

    {
      to: '/institute/news',
      title: 'MENU.NEWS',
      fontIcon: 'far fa-newspaper',
      visible: hasPermission('news_manager'),
    },

    {
      to: '/institute/resources',
      title: 'MENU.RESOURCES',
      fontIcon: 'fas fa-folder-open',
      visible: hasPermission('resource_manager'),
      subLinks: [
        {
          to: '/institute/resources/list',
          title: 'MENU.RESOURCES',
          fontIcon: 'fas fa-folder-open',
          visible: hasPermission('resource_manager_view'),
        },
        {
          to: '/institute/resource-categories/list',
          title: 'MENU.RESOURCE_CATEGORIES',
          fontIcon: 'fas fa-list',
          visible: hasPermission('resource_manager_categories_view'),
        },
        {
          to: '/institute/resource-settings',
          title: 'MENU.RESOURCE_SETTINGS',
          fontIcon: 'fas fa-cog',
          visible: hasPermission('resource_manager_settings'),
        },
      ],
    },

    {
      to: '',
      title: 'MENU.SCHEDULES',
      fontIcon: 'far fa-calendar-alt',
      visible: hasPermission('schedule_manager'),
      subLinks: [
        {
          to: '/institute/schedule/schedule-setting',
          title: 'MENU.SCHEDULES_SETTING',
          fontIcon: 'fas fa-wrench',
          visible: hasPermission('schedule_manager_settings'),
        },
        {
          to: '/institute/schedule/yearly-calendar',
          title: 'MENU.YEARLY_SCHEDULE',
          fontIcon: 'far fa-calendar-alt',
          visible: hasPermission('schedule_manager'),
        },
        {
          to: '/institute/schedule/daily-calendar',
          title: 'MENU.DAILY_SCHEDULE',
          fontIcon: 'far fa-calendar-alt',
          visible: hasPermission('schedule_manager'),
        },
        {
          to: '/institute/schedule/timetable',
          title: 'MENU.AI_SCHEDULE',
          fontIcon: 'far fa-calendar-alt',
          visible: isDevEnv() && hasPermission('schedule_manager'),
        },
      ],
    },

    {
      to: '',
      title: 'MENU.TAGS',
      fontIcon: 'fas fa-tag',
      visible: hasPermission('tags_manager'),
      subLinks: [
        {
          to: '/institute/tags/list',
          title: 'MENU.TAGS',
          fontIcon: 'fas fa-tag',
        },
        {
          to: '/institute/tag-categories/list',
          title: 'MENU.TAGS_CATEGORY',
          fontIcon: 'fas fa-tag',
        },
      ],
    },

    {
      to: '',
      title: 'MENU.USERS',
      fontIcon: 'fas fa-users',
      visible:
        hasPermission('user_manager') &&
        (hasPermission('user_manager_students') ||
          hasPermission('user_manager_parents') ||
          hasPermission('user_manager_teachers') ||
          hasPermission('user_manager_staffs') ||
          hasPermission('user_manager_staff_roles') ||
          hasPermission('user_manager_user_labels') ||
          hasPermission('user_manager_in_active_users') ||
          hasPermission('user_manager_user_letters') ||
          hasPermission('user_manager_settings')),
      subLinks: [
        {
          to:
            isProdEnv() && (isLinksEdu() || isLyceum())
              ? '/institute/user/student'
              : '/institute/student',
          title: 'MENU.STUDENTS',
          fontIcon: 'fas fa-user',
          visible: hasPermission('user_manager_students'),
        },
        {
          to:
            isProdEnv() && (isLinksEdu() || isLyceum())
              ? '/institute/user/parent'
              : '/institute/parent',
          title: 'MENU.PARENTS',
          fontIcon: 'fas fa-user',
          visible: hasPermission('user_manager_parents'),
        },
        {
          to: '/institute/teacher',
          // isProdEnv() && (isLinksEdu() || isLyceum())
          //   ? '/institute/user/teacher'
          //   : '/institute/teacher',
          title: 'MENU.TEACHERS',
          fontIcon: 'fas fa-user',
          visible: hasPermission('user_manager_teachers'),
        },
        {
          to: '/institute/staff',
          // isProdEnv() && (isLinksEdu() || isLyceum())
          //   ? '/institute/user/admin'
          //   : '/institute/staff',
          title: 'MENU.STAFF',
          fontIcon: 'fas fa-user',
          visible: hasPermission('user_manager_staffs'),
        },
        {
          to: '/institute/staff-role',
          // isProdEnv() && (isLinksEdu() || isLyceum())
          //   ? '/institute/staffRole/admin'
          //   : '/institute/staff-role',
          title: 'MENU.STAFF_ROLES',
          fontIcon: 'fas fa-user',
          visible: hasPermission('user_manager_staff_roles'),
        },
        {
          to: '/institute/userLabel/admin',
          title: 'MENU.LABEL',
          fontIcon: 'fas fa-user',
          visible: hasPermission('user_manager_user_labels'),
        },
        {
          to:
            isProdEnv() && (isLinksEdu() || isLyceum())
              ? '/institute/user/unadmin?tabType=student'
              : '/institute/inactive-users/students',
          // generalSettings?.admission_form_permission === 0
          //   ? '/institute/inactive-users/students'
          //   : '/institute/user/unadmin?tabType=student',
          title: 'MENU.IN-ACTIVE_USERS',
          fontIcon: 'fas fa-user',
          visible: hasPermission('user_manager_in_active_users'),
        },
        // {
        //   to: '/institute/generalSettings/admin',
        //   title: 'MENU.SETTINGS',
        //   fontIcon: 'fas fa-wrench',
        //   visible: hasPermission('user_manager_settings'),
        // },
      ],
    },

    /**
     * Academics
     */
    {
      type: 'label',
      title: 'MENU.ACADEMICS',
      to: '',
      visible:
        hasPermission('exam_manager') ||
        hasPermission('extra_curricular_activities') ||
        hasPermission('homework_manager') ||
        hasPermission('performance_report') ||
        hasPermission('quiz_system') ||
        hasPermission('test_manager') ||
        hasPermission('syllabus_manager') ||
        hasPermission('video_lecture'),
    },

    {
      to: '',
      title: 'MENU.CLASSES_&_SUBJECTS',
      fontIcon: 'fas fa-cog',
      visible: hasPermission('class_subject_manager'),
      subLinks: [
        {
          to:
            isProdEnv() && (isLinksEdu() || isLyceum())
              ? '/institute/grades/admin'
              : '/institute/grades',
          title: 'MENU.GRADES',
          fontIcon: 'fas fa-cog',
          visible: hasPermission('class_subject_manager_grades'),
        },
        {
          to:
            isProdEnv() && (isLinksEdu() || isLyceum())
              ? '/institute/sections/admin'
              : '/institute/sections',
          title: 'MENU.SECTIONS',
          fontIcon: 'fas fa-cog',
          visible: hasPermission('class_subject_manager_sections'),
        },
        {
          to:
            isProdEnv() && (isLinksEdu() || isLyceum())
              ? '/institute/classSchool/admin'
              : '/institute/classes',
          title: 'MENU.CLASS',
          fontIcon: 'fas fa-cog',
          visible: hasPermission('class_subject_manager_classes'),
        },
        {
          to:
            isProdEnv() && (isLinksEdu() || isLyceum())
              ? '/institute/subject/admin'
              : '/institute/subjects',
          title: 'MENU.SUBJECT',
          fontIcon: 'fas fa-cog',
          visible: hasPermission('class_subject_manager_subjects'),
        },
      ],
    },

    {
      to: '',
      title: customTitle('MENU.EXAMS'),
      fontIcon: 'fas fa-copy',
      visible: hasPermission('exam_manager'),
      subLinks: [
        {
          to: `/institute/${generalSettings?.use_gradewise_term ? 'gradewiseTerm' : 'term'}/admin`,
          title: 'MENU.TERMS',
          fontIcon: 'fas fa-cog',
          visible: hasPermission('exam_manager_terms'),
        },
        {
          to: `/institute/examGrade/${generalSettings?.grading_key ? 'labelWiseAdmin' : 'admin'}`,
          title: 'MENU.EXAM_GRADE',
          fontIcon: 'fas fa-cog',
          visible: hasPermission('exam_manager_exam_grades'),
        },
        {
          to: '/institute/examType/admin',
          title: 'MENU.EXAM_Type',
          fontIcon: 'fas fa-cog',
          visible: hasPermission('exam_manager_exam_types'),
        },
        {
          to: '/institute/examtypeLabels/admin',
          title: 'MENU.EXAM_TYPE_LABEL',
          fontIcon: 'fas fa-cog',
          visible: hasPermission('exam_manager_exam_type_labels'),
        },
        {
          to: '/institute/exam/admin',
          title: 'MENU.EXAM',
          fontIcon: 'fas fa-file',
          visible: hasPermission('exam_manager_exams'),
        },
        {
          to: '/institute/examReportcardSetting/index',
          title: 'MENU.EXAM_REPORT_CARD_SETTINGS',
          fontIcon: 'fas fa-wrench',
          visible: hasPermission('exam_manager_exam_report_card_settings'),
        },
        {
          to: '/institute/reportcardResult/admin',
          title: 'MENU.NEW_EXAM_REPORT_CARD',
          fontIcon: 'fas fa-copy',
          visible: hasPermission('exam_manager_exam_report_cards'),
        },
        {
          to: '/institute/examReportcardSetting/examScheduleSetting',
          title: 'MENU.EXAM_SHECHDULE_SETTINGS',
          fontIcon: 'far fa-calendar-alt',
          visible: hasPermission('exam_manager_exam_schedule_settings'),
        },
        {
          to: '/institute/exam/datesheet',
          title: 'MENU.EXAM_SCHEDULE',
          fontIcon: 'fas fa-calendar',
          visible: hasPermission('exam_manager_exam_schedules'),
        },
        {
          to: '/institute/exam/report',
          title: 'MENU.LEGACY_EXAM_REPORT_CARD',
          fontIcon: 'fas fa-copy',
          visible:
            hasPermission('exam_manager_exam_report_cards') &&
            [
              'aha',
              'aligarh',
              'dam',
              'dcc',
              'dssk',
              'ha',
              'ibaccdadu',
              'ibakhp',
              'ibapsl',
              'ims',
              'kss',
              'leadership',
              'maniyas',
              'maryammont',
              'psi',
              'psm',
              'sgs',
              'wits',
            ].includes(getTenantName()),
        },
      ],
    },

    {
      to: '',
      title: 'MENU.EX-CURRICULAR_ACTIVITIES',
      fontIcon: 'fas fa-layer-group',
      visible: hasPermission('extra_curricular_activities'),
      subLinks: [
        // {
        //   to: '/institute/site/stream',
        //   title: 'MENU.LIVE_STREAMING',
        //   fontIcon: 'fas fa-bolt',
        //   visible: hasPermission('extra_curricular_activities_live_streaming'),
        // },
        {
          to: '/institute/events/admin',
          title: 'MENU.PHOTO_GALLERY',
          fontIcon: 'la la-photo',
          visible: hasPermission('extra_curricular_activities_photo_gallery'),
        },
        {
          to: '/institute/sportsRecord/admin',
          title: 'MENU.SPORTS',
          fontIcon: 'fas fa-layer-group',
          visible: !isTeacher(),
        },
      ],
    },

    {
      to: isHomeworkBetaEnabled()
        ? isHomeworkBetaToggleEnabled()
          ? '/institute/homeworks'
          : '/institute/homework/admin'
        : isNewHomeworkDisabled() || !isLyceumDevEnv()
          ? '/institute/homework/admin'
          : '/institute/homeworks',
      title: customTitle('MENU.HOMEWORKS'),
      fontIcon: 'fas fa-book-open',
      visible: hasPermission('homework_manager'),
    },

    {
      to: '',
      title: 'MENU.PERFORMANCE_REPORTS',
      fontIcon: 'far fa-copy',
      visible: hasPermission('performance_report'),
      subLinks: [
        {
          to: '/institute/reports/setting',
          title: 'MENU.REPORT_SETTING',
          fontIcon: 'fas fa-wrench',
          visible: hasPermission('performance_report_settings'),
        },
        {
          to: '/institute/reports/homework',
          title: 'MENU.HOMEWORK_REPORT',
          fontIcon: 'far fa-copy',
          visible: hasPermission('performance_report_homework_reports'),
        },
        {
          to: '/institute/reports/test',
          title: 'MENU.TEST_REPORT',
          fontIcon: 'far fa-copy',
          visible: hasPermission('performance_report_test_reports'),
        },

        {
          to: '/institute/reports/exam',
          title: 'MENU.EXAM_REPORT',
          fontIcon: 'far fa-copy',
          visible: hasPermission('performance_report_exam_reports'),
        },

        {
          to: '/institute/reports/overall',
          title: 'MENU.OVERALL_REPORT',
          fontIcon: 'far fa-copy',
          visible: hasPermission('performance_report_overall_reports'),
        },
        {
          to: '/institute/reports/pdfreports',
          title: 'MENU.PDF_REPORTS',
          fontIcon: 'far fa-copy',
          visible: hasPermission('performance_report_pdf_reports'),
        },
        {
          to: '/institute/reports/oALevelReportsNew',
          title: 'MENU.O/A_LEVEL_REPORTS',
          fontIcon: 'far fa-copy',
          visible: hasPermission('performance_report_oa_level_reports'),
        },
        {
          to: '/institute/performance-reports/exam',
          title: 'PERFORMANCE_REPORTS.EXAM_CONSOLIDATE_REPORT.TITLE',
          fontIcon: 'far fa-copy',
          // visible: hasPermission('performance_report_pdf_reports'),
        },
      ],
    },

    {
      to: '',
      title: 'MENU.QUIZ_SYSTEM',
      fontIcon: 'far fa-file',
      visible: hasPermission('quiz_system'),
      subLinks: [
        {
          to: '/institute/quizsystem/quizDifficultylevel/admin',
          title: 'MENU.DIFFICULTY_LEVEL',
          fontIcon: 'fas fa-list',
          visible: hasPermission('quiz_system_difficulty_level'),
        },
        {
          to: '/institute/quizsystem/quizLabel/admin',
          title: 'MENU.LABEL',
          fontIcon: 'fas fa-list',
          visible: hasPermission('quiz_system_label'),
        },
        {
          to: '/institute/quizsystem/quizQuestion/admin',
          title: 'MENU.QUESTION',
          fontIcon: 'fas fa-list',
          visible: hasPermission('quiz_system_question'),
        },
        {
          to: '/institute/quizsystem/quizsystem/settings',
          title: 'MENU.SETTINGS',
          fontIcon: 'fas fa-wrench',
          visible: hasPermission('quiz_system_settings'),
        },
      ],
    },

    {
      to: isDevEnv() ? '/institute/tests' : '/institute/test/admin',
      title: customTitle('MENU.TESTS'),
      fontIcon: 'fas fa-address-book',
      visible: hasPermission('test_manager'),
    },

    {
      to: '/institute/sallaybus/admin',
      title: 'MENU.SYLLABUS_MANAGER',
      fontIcon: 'far fa-edit',
      visible: hasPermission('syllabus_manager'),
    },

    {
      to: '',
      title: 'MENU.VIDEO_LECTURES',
      fontIcon: 'fas fa-film',
      visible: hasPermission('video_lecture'),
      subLinks: [
        {
          to: '/institute/lectures-new/list?type=0',
          // to: '/institute/lectures-new/list?type=0',
          title: 'MENU.RECORDED_LECTURES',
          fontIcon: 'fas fa-film',
        },
        {
          to: '/institute/lectures-new/list?type=1',
          // to: '/institute/lectures-new/list?type=1',
          title: 'MENU.LIVE_LECTURES',
          fontIcon: 'fas fa-camera-retro',
        },
      ],
    },

    /**
     * Finance
     */
    {
      type: 'label',
      title: 'MENU.FINANCE',
      to: '',
      visible:
        hasPermission('account_manager') ||
        hasPermission('fee_manager') ||
        hasPermission('finance_manager') ||
        hasPermission('hr_manager') ||
        hasPermission('royalty_manager') ||
        hasPermission('vendors_module'),
    },

    {
      to: '',
      title: 'MENU.ACCOUNTS',
      fontIcon: 'fas fa-briefcase',
      visible: hasPermission('account_manager'),
      subLinks: [
        {
          to: '/institute/am/default/settings',
          title: 'MENU.ACCOUNTS_SETTINGS',
          fontIcon: 'fas fa-cog',
          visible: hasPermission('account_manager_settings'),
        },

        {
          to: isDevEnv() ? '/institute/accountType' : '/institute/am/accountType/admin',
          title: 'MENU.ACCOUNT_TYPES',
          fontIcon: 'fas fa-list',
          visible: hasPermission('account_manager_types'),
        },
        {
          to: '/institute/am/account/admin',
          title: 'MENU.CHART_OF_ACCOUNTS',
          fontIcon: 'fas fa-copy',
          visible: hasPermission('account_manager_chart_of_accounts'),
        },
        // {
        //   to: '/institute/am/actmVendor/admin',
        //   title: 'MENU.VENDORS',
        //   fontIcon: 'fas fa-users',
        //   visible: hasPermission('account_manager_vendors'),
        // },
        {
          to: '/institute/am/transaction/billIndex',
          title: customTitle('MENU.PAYMENT_VOUCHERS'),
          fontIcon: 'far fa-edit',
          visible: hasPermission('account_manager_payment_vouchers'),
        },
        {
          to: '/institute/am/transaction/bpvIndex',
          title: customTitle('MENU.BANK_PAYMENT_VOUCHERS'),
          fontIcon: 'far fa-edit',
        },
        {
          to: '/institute/am/transaction/cpvIndex',
          title: customTitle('MENU.CASH_PAYMENT_VOUCHERS'),
          fontIcon: 'far fa-edit',
        },
        {
          to: '/institute/am/transaction/invoiceIndex',
          title: customTitle('MENU.RECEIPT_VOUCHERS'),
          fontIcon: 'far fa-edit',
          visible: hasPermission('account_manager_receipt_vouchers'),
        },
        {
          to: '/institute/am/transaction/pettyCashIndex',
          title: 'MENU.PETTY_CASH_VOUCHERS',
          fontIcon: 'far fa-edit',
          visible: hasPermission('account_manager_petty_cash_vouchers'),
        },
        {
          to: '/institute/am/manualJournal/index',
          title: 'MENU.MANUAL_JOURNALS',
          fontIcon: 'far fa-edit',
          visible: hasPermission('account_manager_manual_journals'),
        },
        {
          to: '',
          title: 'MENU.REPORTS',
          fontIcon: 'fas fa-copy',
          subLinks: [
            {
              to: '/institute/am/profitLoss/statementRaw',
              title: 'MENU.PROFIT_&_LOSS',
              fontIcon: 'fas fa-copy',
            },
            {
              to: '/institute/am/balanceSheet/statementRaw',
              title: 'MENU.BALANCE_SHEET',
              fontIcon: 'fas fa-copy',
            },
            {
              to: '/institute/am/generalLedger/report?method=raw',
              title: 'MENU.GENERAL_LEDGER',
              fontIcon: 'fas fa-copy',
            },
            {
              to: '/institute/am/trialBalance/report',
              title: 'MENU.TRIAL_BALANCE',
              fontIcon: 'fas fa-copy',
            },
            // {
            //   to: '/institute/am/trialBalance/report?new=true',
            //   title: 'MENU.TRIAL_BALANCE_NEW',
            //   fontIcon: 'fas fa-copy',
            // },
            {
              to: '/institute/am/accountDetail/reportRaw',
              title: 'MENU.DETAILED_ACCOUNTS_REPORT',
              fontIcon: 'fas fa-copy',
            },
            {
              to: '/institute/am/reconciliationReport/report',
              title: 'MENU.BANK_RECONCILIATION_STATEMENT',
              fontIcon: 'fas fa-copy',
            },
            {
              to: '/institute/am/agingReport/report',
              title: 'MENU.AGING_REPORT',
              fontIcon: 'fas fa-copy',
            },
            {
              to: '/institute/am/ledgerReport/report',
              title: 'MENU.LEDGER_REPORT',
              fontIcon: 'fas fa-copy',
            },
            {
              to: '/institute/am/vendorLedger/report',
              title: 'MENU.VENDOR_LEDGER_REPORT',
              fontIcon: 'fas fa-copy',
            },
            {
              to: '/institute/am/newReconciliation/report',
              title: 'MENU.NEW_BANK_RECONCILIATION_REPORT',
              fontIcon: 'fas fa-copy',
            },
            {
              to: '/institute/am/receiptReport/report',
              title: 'MENU.RECEIPT_REPORT',
              fontIcon: 'fas fa-copy',
            },
          ],
        },
        {
          to: '/institute/am/accountRecordLog/admin',
          title: 'MENU.ACCOUNTS_DETAIL_LOG',
          fontIcon: 'far fa-file',
          visible: hasPermission('account_manager_detail_logs'),
        },
        {
          to: '/institute/am/actmReportConfig/admin',
          title: 'MENU.CUSTOM_REPORTS',
          fontIcon: 'fas fa-gear',
        },
      ],
    },

    {
      to: '',
      title: 'MENU.FEES',
      fontIcon: 'fas fa-wallet',
      visible: hasPermission('fee_manager'),
      subLinks: [
        {
          to: '/institute/finance/feeParticular/admin',
          title: 'MENU.FEE_PARTICULAR',
          fontIcon: 'fas fa-list',
          visible: hasPermission('fee_manager_fee_particulars'),
        },
        {
          to: '/institute/finance/feeDiscount/admin',
          title: 'MENU.FEE_DISCOUNT',
          fontIcon: 'fas fa-list',
          visible: hasPermission('fee_manager_fee'),
        },
        {
          to: '/institute/finance/feeCollection/admin',
          title: 'MENU.FEE_COLLECTION',
          fontIcon: 'fas fa-list',
          visible: hasPermission('fee_manager_fee_collection'),
        },
        {
          to: '/institute/finance/feeCollection/reports',
          title: 'MENU.REPORTS',
          fontIcon: 'fas fa-copy',
          visible: hasPermission('fee_manager_defaulter_reports'),
        },
        {
          to: '/institute/finance/feeSettings/settings',
          title: 'MENU.FEE_SETTINGS',
          fontIcon: 'fas fa-wrench',
          visible: hasPermission('fee_manager_settings'),
        },
        {
          to: '/institute/finance/bankAccount/admin',
          title: 'MENU.BANK_ACCOUNTS',
          fontIcon: 'fas fa-list',
          visible: hasPermission('fee_manager_bank_accounts'),
        },
      ],
    },

    {
      to: '',
      title: 'MENU.FINANCES',
      fontIcon: 'fas fa-briefcase',
      visible: hasPermission('finance_manager'),
      subLinks: [
        {
          to: '/institute/finance/assetCategory/admin',
          title: 'MENU.ASSET_CATEGORY',
          fontIcon: 'fas fa-list',
          visible: hasPermission('finance_manager_asset_categories'),
        },
        {
          to: '/institute/finance/financeAsset/admin',
          title: 'MENU.ASSETS',
          fontIcon: 'fas fa-list',
          visible: hasPermission('finance_manager_assets'),
        },
        {
          to: '/institute/finance/expenseCategory/admin',
          title: 'MENU.EXPENSE_CATEGORY',
          fontIcon: 'fas fa-list',
          visible: hasPermission('finance_manager_expense_categories'),
        },
        {
          to: '/institute/finance/financeExpense/admin',
          title: 'MENU.EXPENSES',
          fontIcon: 'fas fa-list',
          visible: hasPermission('finance_manager_expenses'),
        },
        {
          to: '/institute/finance/finance/incomereport',
          title: 'MENU.INCOME/REVENUE',
          fontIcon: 'fas fa-copy',
          visible: hasPermission('finance_manager_income_revenue'),
        },
        {
          to: '/institute/finance/finance/incomeexpensereport',
          title: 'MENU.INCOME_AND_EXPENSE_REPORT',
          fontIcon: 'fas fa-copy',
          visible: hasPermission('finance_manager_income_expense_report'),
        },
      ],
    },

    {
      to: '',
      title: 'MENU.HUMAN_RESOURCES',
      fontIcon: 'fas fa-user-plus',
      visible: hasPermission('hr_manager'),
      subLinks: [
        {
          to: '/institute/hr/hrPayroll/admin',
          title: 'MENU.PAYROLL',
          fontIcon: 'fas fa-list',
          visible: hasPermission('hr_manager_payroll'),
        },
        {
          to: '/institute/hr/hr/employees',
          title: 'MENU.EMPLOYEES',
          fontIcon: 'fas fa-list',
          visible: hasPermission('hr_manager_employees'),
        },
        {
          to: '/institute/hr/hr/salaryrecord',
          title: 'MENU.SALARY_RECORD',
          fontIcon: 'fas fa-list',
          visible: hasPermission('hr_manager_salary_records'),
        },
        {
          to: '/institute/hr/hr/settings',
          title: 'MENU.HR_SETTINGS',
          fontIcon: 'fas fa-wrench',
          visible: hasPermission('hr_manager_settings'),
        },
      ],
    },

    {
      to: '',
      title: 'MENU.ROYALTIES',
      fontIcon: 'fas fa-briefcase',
      visible: hasPermission('royalty_manager'),
      subLinks: [
        {
          to:
            isDevEnv() || ['tres'].includes(getTenantName())
              ? '/institute/royalty'
              : '/institute/royality/royalityInvoice/create',
          title: 'MENU.ROYALTY_INVOICE',
          fontIcon: 'fas fa-list',
        },
      ],
    },

    {
      to: '',
      title: 'MENU.VENDORS',
      fontIcon: 'fas fa-users',
      visible: hasPermission('vendors_module'),
      subLinks: [
        {
          to: '/institute/vendors',
          title: 'MENU.VENDORS',
          fontIcon: 'fas fa-users',
        },
        {
          to: '/institute/vendors/add',
          title: 'MENU.ADD_VENDOR',
          fontIcon: 'fas fa-users',
          visible: hasPermission('vendors_module_create'),
        },
        {
          to: '/institute/vendors/settings',
          title: 'MENU.VENDOR_SETTINGS',
          fontIcon: 'fas fa-users',
          visible: hasPermission('vendors_module_settings'),
        },
      ],
    },

    /**
     * Management
     */
    {
      type: 'label',
      title: 'MENU.MANAGEMENT',
      to: '',
      visible:
        hasPermission('blog_manager') ||
        hasPermission('inventory_manager') ||
        hasPermission('user_manager_user_letters') ||
        hasPermission('library_module') ||
        hasPermission('notification_manager') ||
        hasPermission('request_manager') ||
        hasPermission('cms_module') ||
        hasPermission('observation_manager'),
    },

    {
      to: '',
      title: 'MENU.OBSERVATION_HEADING',
      fontIcon: 'far fa-clipboard',
      visible: hasPermission('observation_manager') && isDevEnv(),
      subLinks: [
        {
          to: isDevEnv() ? '/institute/forms' : '',
          title: 'MENU.FORMS',
          fontIcon: 'fas fa-file-alt',
          visible: hasPermission('form_manager'),
        },
        {
          to: isDevEnv() ? '/institute/observations' : '',
          title: 'MENU.OBSERVATIONS',
          fontIcon: 'fas fa-edit',
          visible: hasPermission('observation_manager'),
        },
        {
          to: isDevEnv() ? '/institute/questions' : '',
          title: 'MENU.QUESTIONS',
          fontIcon: 'fas fa-circle-question',
          visible: hasPermission('form_question_manager'),
        },
        {
          to: isDevEnv() ? '/institute/observations/observation-settings' : '',
          title: 'MENU.SETTINGS',
          fontIcon: 'fas fa-cog',
          visible: hasPermission('form_manager_update'),
        },
      ],
    },

    {
      to: '',
      title: 'MENU.BLOGS',
      fontIcon: 'far fa-comment-dots',
      visible: hasPermission('blog_manager'),
      subLinks: [
        {
          to: '/institute/schoolblog/blogCategory/admin',
          title: 'MENU.CATEGORY',
          fontIcon: 'fas fa-cog',
          visible: hasPermission('blog_manager_categories'),
        },
        {
          to: '/institute/schoolblog/blogPosts/admin',
          title: 'MENU.POSTS',
          fontIcon: 'far fa-copy',
          visible: hasPermission('blog_manager_posts'),
        },
        {
          to: '/institute/schoolblog/blogComments/admin',
          title: 'MENU.COMMENTS',
          fontIcon: 'fas fa-comments',
          visible: hasPermission('blog_manager_comments'),
        },
        {
          to: '/institute/schoolblog/bannedwords/admin',
          title: 'MENU.BANNED_WORDS',
          fontIcon: 'fas fa-ban',
          visible: hasPermission('blog_manager_banned_words'),
        },
        {
          to: '/institute/schoolblog/blogs',
          title: 'MENU.BLOG_FRONT_VIEW',
          fontIcon: 'fas fa-comment-dots',
          visible: hasPermission('blog_manager_blogs'),
        },
      ],
    },

    {
      to: '',
      title: 'MENU.INVENTORY',
      fontIcon: 'fas fa-list',
      visible: hasPermission('inventory_manager'),
      subLinks: [
        {
          to: isDevEnv()
            ? '/institute/inventory/item-categories/list'
            : '/institute/inventory/itemCategory/admin',
          title: 'MENU.ITEM_CATEGORIES',
          fontIcon: 'fas fa-list',
          visible: hasPermission('inventory_manager_item_categories'),
        },
        {
          to: isDevEnv()
            ? '/institute/inventory/store-items/list'
            : '/institute/inventory/storeItem/admin',
          title: 'MENU.STORE_ITEMS',
          fontIcon: 'fas fa-list',
          visible: hasPermission('inventory_manager_store_items'),
        },
        {
          to: isDevEnv()
            ? '/institute/inventory/invoices/list'
            : '/institute/inventory/invoice/admin',
          title: generalSettings?.invoice_button_name
            ? generalSettings.invoice_button_name
            : 'MENU.INVOICES',
          fontIcon: 'fas fa-list',
          visible: hasPermission('inventory_manager_invoices'),
        },
        {
          to: isDevEnv()
            ? '/institute/inventory/purchase-orders/list'
            : '/institute/inventory/purchaseOrder/admin',
          title: 'MENU.PURCHASE_ORDERS',
          fontIcon: 'fas fa-list',
          visible: hasPermission('inventory_manager_purchase_orders'),
        },
        {
          to: isDevEnv()
            ? '/institute/inventory/goods-receipts/list'
            : '/institute/inventory/goodsReceipt/admin',
          title: 'MENU.GOODS_RECEIPTS',
          fontIcon: 'fas fa-list',
          visible: hasPermission('inventory_manager_goods_receipts'),
        },
        {
          to: isDevEnv()
            ? '/institute/inventory/stock-report'
            : '/institute/inventory/report/reportIndex',
          title: 'MENU.REPORTS',
          fontIcon: 'fas fa-list',
          visible: hasPermission('inventory_manager_reports') && !isStaff(),
        },
        {
          to: isDevEnv()
            ? '/institute/inventory/inventory-settings'
            : '/institute/inventory/inventorySettings/update',
          title: 'SETTINGS_CATEGORY.INVENTORY_SETTINGS',
          fontIcon: 'fas fa-cog',
          visible: hasPermission('inventory_manager_reports') && !isStaff(),
        },
      ],
    },

    {
      to: '/institute/certificates',
      title: 'MENU.LETTERS_AND_CERTIFICATES',
      fontIcon: 'fas fa-file',
      visible: hasPermission('user_manager_user_letters'),
    },

    {
      to: '',
      title: 'MENU.LIBRARY',
      fontIcon: 'fas fa-university',
      visible: hasPermission('library_module') && !isTeacher(),
      subLinks: [
        {
          to: '/institute/category/list',
          title: 'MENU.LIBRARY_CATEGORY',
          fontIcon: 'fas fa-list-alt',
          visible: hasPermission('library_module_categories'),
        },
        {
          to: '/institute/subject/list',
          title: 'MENU.LIBRARY_SUBJECT',
          fontIcon: 'fas fa-address-card',
          visible: hasPermission('library_module_subjects'),
        },
        {
          to: '/institute/book/list',
          title: 'MENU.LIBRARY_BOOK',
          fontIcon: 'fas fa-book',
          visible: hasPermission('library_module_books'),
        },
        {
          to: '/institute/bookReservation/list',
          title: 'MENU.BOOK_RESERVATION',
          fontIcon: 'fas fa-calendar-alt',
          visible: hasPermission('library_module_book_issuance'),
        },
        {
          to: '/institute/book-settings',
          title: 'MENU.BOOK_SETTING',
          fontIcon: 'fas fa-cog',
          visible: hasPermission('library_module_settings'),
        },
      ],
    },

    {
      to: '',
      title: 'MENU.NOTIFICATIONS',
      fontIcon: 'fa fa-bell',
      visible: hasPermission('notification_manager'),
      subLinks: [
        {
          to: '/institute/notifications/setting',
          title: 'MENU.NOTIFICATIONS_SETTING',
          fontIcon: 'fa fa-bell',
          visible: hasPermission('notification_manager_settings'),
        },
        {
          to: '/institute/emailSettings/update',
          title: 'MENU.EMAIL_SETTING',
          fontIcon: 'fa fa-envelope',
          visible: hasPermission('notification_manager_email_settings'),
        },
        {
          to: '/institute/notifications/admin',
          fontIcon: 'far fa-bell',
          title: 'MENU.NOTIFICATIONS',
          visible: hasPermission('notification_manager_notifications'),
        },
      ],
    },

    {
      to: '',
      title: 'MENU.STAFF_REQUESTS',
      fontIcon: 'fas fa-envelopes-bulk',
      visible: hasPermission('request_manager'),
      subLinks: [
        {
          to: '/institute/requests/list',
          title: 'MENU.REQUESTS',
          fontIcon: 'fas fa-file-pen',
        },
        {
          to: '/institute/requests/settings',
          title: 'MENU.REQUEST_SETTINGS',
          fontIcon: 'fas fa-gear',
          visible: hasPermission('request_manager_settings'),
        },
      ],
    },

    {
      to: '',
      title: 'MENU.WEBSITE',
      fontIcon: 'fas fa-list',
      visible: hasPermission('cms_module'),
      subLinks: [
        {
          to: '/institute/cms/cmsControlls/admin',
          title: 'MENU.WEBSITE_SETTINGS',
          fontIcon: 'fas fa-cog',
          visible: hasPermission('cms_module_settings'),
        },
        {
          to: '/institute/cms/cmsPages/admin',
          title: 'MENU.PAGES',
          fontIcon: 'fas fa-list',
          visible: hasPermission('cms_module_pages'),
        },
      ],
    },

    /**
     * Other
     */
    {
      type: 'label',
      title: 'MENU.OTHER',
      to: '',
      visible: hasPermission('data_upload_manager') || hasPermission('system_reports'),
    },

    {
      to: '',
      title: 'MENU.DATA_IMPORT',
      fontIcon: 'fas fa-cloud-upload-alt',
      visible: hasPermission('data_upload_manager'),
      subLinks: [
        {
          to: '/institute/data-import/class-subject-teacher/upload',
          title: 'MENU.CLASS/SUBJECT/TEACHER',
          fontIcon: 'fas fa-cogs',
          visible: hasPermission('data_upload_manager_class_subject_teachers'),
        },
        {
          to: '/institute/data-import/student-parent/upload',
          title: 'MENU.STUDENT/PARENT',
          fontIcon: 'fas fa-users',
          visible: hasPermission('data_upload_manager_student_parents'),
        },
        {
          // to: '/institute/data-import/user-labels/upload',
          to: '/institute/dataupload/default/ulAdmin',
          title: 'MENU.USER_LABEL',
          fontIcon: 'fas fa-tags',
        },
        {
          to: '/institute/dataupload/default/dsAdmin',
          title: 'MENU.DAILY_SCHEDULE',
          fontIcon: 'fas fa-calendar',
          visible: hasPermission('data_upload_manager_daily_schedules'),
        },
        {
          to: '/institute/dataupload/default/subAttnAdmin',
          title: 'MENU.SUBJECT_ATTENDANCE',
          fontIcon: 'fas fa-calendar',
        },
        {
          to: isDevEnv()
            ? '/institute/data-import/annual-calendar/upload'
            : '/institute/dataupload/default/ysAdmin',
          title: 'MENU.YEARLY_SCHEDULE',
          fontIcon: 'fas fa-calendar',
          visible: hasPermission('data_upload_manager_yearly_schedules'),
        },
        {
          to: '/institute/dataupload/default/prevGradesAdmin',
          title: 'MENU.STUDENT_PREVIOUS_GRADE',
          fontIcon: 'fas fa-calendar',
        },
        {
          to: '/institute/dataupload/default/prevPercentagesAdmin',
          title: 'MENU.STUDENT_PREVIOUS_PERCENTAGES',
          fontIcon: 'fas fa-calendar',
        },
        {
          to: '/institute/dataupload/default/soAdmin',
          title: 'MENU.SUBJECTS_OUTLINE',
          fontIcon: 'fas fa-file',
          visible: hasPermission('data_upload_manager_subject_outlines'),
        },
        {
          to: '/institute/dataupload/default/discountAdmin',
          title: 'MENU.DISCOUNT',
          fontIcon: 'fas fa-file',
        },
        {
          // to: '/institute/data-import/tags/upload',
          to: '/institute/dataupload/default/tagsAdmin',
          title: 'MENU.TAGS',
          fontIcon: 'fas fa-tags',
        },
        {
          // to: '/institute/data-import/store-items/upload',
          to: '/institute/dataupload/default/inAdmin',
          title: 'MENU.STORE_ITEMS',
          fontIcon: 'fas fa-file-alt',
        },
        {
          to: '/institute/data-import/student-homework/upload',
          title: 'MENU.STUDENT_HOMEWORK',
          fontIcon: 'fas fa-file-alt',
        },
        {
          to: '/institute/data-import/student-test/upload',
          title: 'MENU.STUDENT_TEST',
          fontIcon: 'fas fa-file-alt',
        },
        {
          // to: '/institute/data-import/student-exam/upload',
          to: '/institute/dataupload/default/examAdmin',
          title: 'MENU.STUDENT_EXAM',
          fontIcon: 'fas fa-file-alt',
        },
        {
          to: '/institute/dataupload/default/cgAdmin',
          title: 'MENU.CAIE_CONSOLIDATED_RESULT',
          fontIcon: 'fas fa-file-alt',
        },
        {
          to: '/institute/dataupload/default/scAdmin',
          title: 'MENU.CAIE_SUBJECT_COMPONENTS_RESULT',
          fontIcon: 'fas fa-file-alt',
        },
        {
          to: '/institute/dataupload/default/prvAdmin',
          title: 'MENU.POST_REPORT_CARD_VARIABLE_DATA',
          fontIcon: 'fas fa-file-alt',
        },
        {
          to: '/institute/dataupload/manualJournalUpload/BulkMj',
          title: 'MENU.ACCOUNTS_IMPORT',
          fontIcon: 'fas fa-file-import',
        },
      ],
    },

    {
      to: '',
      title: 'MENU.SYSTEM_REPORTS',
      fontIcon: 'fas fa-folder',
      visible: hasPermission('system_reports'),
      subLinks: [
        {
          to: '/institute/notificationLog/admin',
          title: 'MENU.NOTIFICATIONS_REPORT',
          fontIcon: 'fas fa-file',
          visible: hasPermission('system_reports_notification_reports'),
        },
        {
          to: '/institute/smsLog/admin',
          title: 'MENU.SMS_REPORT',
          fontIcon: 'fas fa-file',
          visible: hasPermission('system_reports_sms_reports'),
        },
        {
          to: '/institute/WhatsappLogs/admin',
          title: 'MENU.WHATSAPP_LOG',
          fontIcon: 'fas fa-file',
          visible: isAdmin(),
        },
        {
          to: '/institute/dblog/admin',
          title: 'MENU.DATABASE_LOG',
          fontIcon: 'fas fa-file',
          visible: isAdmin(),
        },
        {
          to: '',
          title: 'MENU.BIOMETRIC',
          fontIcon: 'fas fa-folder',
          visible: isAdmin(),
          subLinks: [
            {
              to: '/institute/activeRecordLog/admin',
              title: 'MENU.BIOMETRIC_API_ACCESS_LOG',
              fontIcon: 'fas fa-file',
            },
            {
              to: '/institute/biometricCsvLog',
              title: 'MENU.BIOMETRIC_CSV_LOG',
              fontIcon: 'fas fa-file',
            },
            {
              to: '/institute/biometricDeviceLog',
              title: 'MENU.BIOMETRIC_DEVICE_LOG',
              fontIcon: 'fas fa-file',
            },
            {
              to: '/institute/biometricLog',
              title: 'MENU.BIOMETRIC_LOG',
              fontIcon: 'fas fa-file',
            },
            {
              to: '/institute/BiometricCsvLogs/upload',
              title: 'MENU.BIOMETRIC_FILE_UPLOAD',
              fontIcon: 'fas fa-file',
            },
            {
              to: '/institute/BiometricCsvLogs/attendanceUpload',
              title: 'MENU.ATTENDANCE_FILE_UPLOAD',
              fontIcon: 'fas fa-file',
            },
            {
              to: '/institute/BiometricCsvLogs/diagnose',
              title: 'MENU.DIAGNOSES',
              fontIcon: 'fas fa-file',
            },
          ],
        },
      ],
    },

    // {
    //   to: `/institute/contact-support?${queryParams}`,
    //   title: 'MENU.CONTACT_SUPPORT',
    //   fontIcon: 'fa fa-headset',
    //   visible: hasPermission('support_module'),
    // },

    // {
    //   to: 'https://ilmversity.com/knowledge-base/',
    //   target: '_blank',
    //   external: true,
    //   title: 'MENU.KNOWLEDGE_BASE',
    //   fontIcon: 'fas fa-book-open',
    //   hasBullet: false,
    //   visible: hasPermission('knowledge_base'),
    // },
  ]
}
